module.exports = __webpack_public_path__ + "static/media/teaching_server_icon_2.edc2e02c.svg";